import { render, staticRenderFns } from "./AffiliateConfirmModal.vue?vue&type=template&id=4d6ec8b7"
import script from "./AffiliateConfirmModal.vue?vue&type=script&lang=js"
export * from "./AffiliateConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports